import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><g transform=\"rotate(-45 18.107 7.5)\"><circle cx=\"10\" cy=\"10\" r=\"10\" stroke=\"none\"></circle><circle cx=\"10\" cy=\"10\" r=\"9\"></circle></g><path d=\"m20.57 21.428 9 9\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }